import * as React from 'react';
import {
    FilterList,
    FilterListItem,
    useStore,
    useListFilterContext,
} from 'react-admin';
import clsx from 'clsx';
import Button from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

interface StaticFilterListItem {
    label: string;
    value: Record<string, any>;
}

interface StaticFilterListProps {
    source: string;
    label: string;
    icon: any;
    items: StaticFilterListItem[];
    className?: string;
}

// Collapsible filter for fixed options, matching CustomFilterList's drop-to-hide UX (no backend URL).
const StaticFilterList = ({
    source,
    label,
    icon,
    items,
    className,
}: StaticFilterListProps) => {
    const { resource } = useListFilterContext();
    const [filterListSettings, setFilterListSettings] = useStore(
        `${resource}.filterList`,
        ''
    );

    const getFilterListMode: any = () =>
        filterListSettings !== '' &&
        filterListSettings[source] &&
        filterListSettings[source].mode
            ? filterListSettings[source].mode
            : '';

    const setFilterListMode: any = c => {
        let settings =
            filterListSettings !== ''
                ? JSON.parse(JSON.stringify(filterListSettings))
                : {};
        settings = { ...settings, [source]: { mode: c } };
        setFilterListSettings(settings);
    };

    const handleOnClick: any = () => {
        getFilterListMode() !== ''
            ? setFilterListMode('')
            : setFilterListMode('_close');
    };

    return (
        <div style={{ display: 'grid' }}>
            <Button
                onClick={handleOnClick}
                className={clsx(`close_button${getFilterListMode()}`)}
            >
                {getFilterListMode() === '' ? (
                    <ArrowDropDownIcon />
                ) : (
                    <ArrowRightIcon />
                )}
            </Button>
            <FilterList
                label={label}
                icon={icon}
                className={clsx(
                    `OopFilterList${getFilterListMode()}`,
                    `oop-filterlist-${source}${getFilterListMode()}`,
                    className
                )}
            >
                {items.map((item, index) => (
                    <FilterListItem
                        label={item.label}
                        key={`${source}_${index}`}
                        value={item.value}
                    />
                ))}
            </FilterList>
        </div>
    );
};

export default StaticFilterList;
